// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"533dddbd","901":"03a0e052"}[chunkId] + ".chunk.css";
};